export const CANDIDATE_LIST_REQUEST = "CANDIDATE_LIST_REQUEST";

export const CANDIDATE_PERSONAL_INFO_REQUEST = "CANDIDATE_PERSONAL_INFO_REQUEST";
export const CANDIDATE_ADDRESS_INFO_REQUEST = "CANDIDATE_ADDRESS_INFO_REQUEST";
export const CANDIDATE_KEY_SKILLS_REQUEST = "CANDIDATE_KEY_SKILLS_REQUEST";
export const CANDIDATE_CERTIFICATIONS_REQUEST = "CANDIDATE_CERTIFICATIONS_REQUEST";
export const CANDIDATE_EDUCATION_REQUEST = "CANDIDATE_EDUCATION_REQUEST";
export const CANDIDATE_WORK_EXPERIENCE_REQUEST = "CANDIDATE_WORK_EXPERIENCE_REQUEST";
export const CANDIDATE_ACCOMPLISHMENTS_REQUEST = "CANDIDATE_ACCOMPLISHMENTS_REQUEST";
export const CANDIDATE_DOC_INFO_REQUEST = "CANDIDATE_DOC_INFO_REQUEST";
export const CANDIDATE_JOB_PREFERENCES_REQUEST = "CANDIDATE_JOB_PREFERENCES_REQUEST";
export const DESIGNATION_DROPDOWN_REQUEST = "DESIGNATION_DROPDOWN_REQUEST";
export const DEGREE_TYPE_DROPDOWN_REQUEST = "DEGREE_TYPE_DROPDOWN_REQUEST";
